import type { DatabaseSourceInfo } from '@ditto/shared';
import type { FC } from 'react';
import { Fda510kInputs } from './Fda510kInputs';
import { FdaRecallInputs } from './FdaRecallInputs';
import { MaudeInputs } from './MaudeInputs';
import { PremarketApprovalInputs } from './PremarketApprovalInputs';
import { PubmedInputs } from './PubmedInputs';
import { SimpleTextInputs } from './SimpleTextInputs';

export interface DatabaseInputComponentProps {
  initialQuery: string;
  onQueryChange: (query: string, isValid: boolean) => void;
  source: DatabaseSourceInfo;
  showErrors: boolean;
  setShowErrors: (showErrors: boolean) => void;
}

export const getDatabaseInputComponent = (
  source: DatabaseSourceInfo
): FC<DatabaseInputComponentProps> => {
  switch (source.id) {
    case 'maude_adverse_events':
      return MaudeInputs;
    case 'fda_recall':
      return FdaRecallInputs;
    case 'fda_510k_submissions':
      return Fda510kInputs;
    case 'premarket_approval':
      return PremarketApprovalInputs;
    case 'clinical_trials':
      return SimpleTextInputs;
    case 'pubmed':
      return PubmedInputs;
    default:
      return SimpleTextInputs;
  }
};
